import React from "react";
import { SectionHeader } from "@/components/design-system/SectionHeader/SectionHeader";
import { ExperienceCard } from "@/components/design-system/ExperienceCard/ExperienceCard";
import { cards } from "./EmployerEmployeeExperienceSection.data";

export const EmployerEmployeeExperienceSection: React.FC = () => (
  <section className="bg-primary-700 w-full overflow-hidden">
    <div className="mx-auto max-w-360 px-5 py-16 md:px-8 md:py-24 lg:px-16">
      <div className="mb-12 md:mb-16">
        <SectionHeader
          label="Employee Experience"
          heading="A financial benefit employees actually use."
          description="Replace static benefit portals with a conversational financial health companion — available whenever your employees need it most."
          theme="dark"
        />
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-4 xl:mx-auto xl:max-w-282">
        {cards.map((card) => (
          <ExperienceCard key={card.title} image={card.image} title={card.title} description={card.description} />
        ))}
      </div>
    </div>
  </section>
);
